
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('UserSchema', function (Parse) {

		// Define 'User' scheme
		let schema = [
			'email',
			'username',
			'full_name',
			'profile',
			'verification_data',
			'integrations',
			'elevated'
		];

		// Load the schema into the object prototype
		schema.forEach(function (field) {
			Object.defineProperty(Parse.User.prototype, field, {
				get: function () { return this.get(field); },
				set: function (value) { return this.set(field, value); }
			});
		});

		return Parse.User;

	});
}




// WEBPACK FOOTER //
// ./src/app/core/schemas/user.schema.js